import {ChangeDetectionStrategy, Component, computed, inject, input, output} from '@angular/core';
import {CdkTextareaAutosize} from "@angular/cdk/text-field";
import {
    FileUploadCardComponent
} from "../../../../../../../../shared/components/ui/file-upload-card/file-upload-card.component";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {DesignBlockData} from "../../../base-design-block-modal/types/base-design-block.types";
import {defaultDesignBlockData} from "../../../base-design-block-modal/configs/default-design-block-data";
import {AttachFileParams, EntityFileType} from "../../../../../../../../core/types/file.types";
import {
  BaseDesignBlockPathStateService
} from "../../../base-design-block-modal/services/base-design-block-path-state.service";
import {BannerSocialFilesService} from "../../services/banner-social-files.service";
import {BannerSocialFilesStateService} from "../../services/banner-social-files-state.service";
import {RecordUpdateRequestParams} from "../../../../../../../../core/types/records-table.types";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'div[app-banners-social-bottom]',
  imports: [
    CdkTextareaAutosize,
    FileUploadCardComponent,
    MatFormField,
    MatInput,
    MatLabel,
    FormsModule
  ],
  templateUrl: './banners-social-bottom.component.html',
  styleUrl: './banners-social-bottom.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannersSocialBottomComponent {
  designBlockData = input<DesignBlockData>(defaultDesignBlockData);
  isEditModeActive = input<boolean>(false);
  isActiveUploadFile = input<boolean>(false);
  bannerSocialEntityFileType = input<EntityFileType>('BANNERS');
  updateComment = output<DesignBlockData>();
  attachFile = output<AttachFileParams>();

  private baseDesignBlockPathStateService: BaseDesignBlockPathStateService = inject(BaseDesignBlockPathStateService);
  private bannerSocialFilesService: BannerSocialFilesService = inject(BannerSocialFilesService);
  private bannerSocialFilesStateService: BannerSocialFilesStateService = inject(BannerSocialFilesStateService);

  public remainingFileSlots = computed(() => this.bannerSocialFilesStateService.getRemainingFileSlots());

  public async handleUpdateComment(): Promise<void> {
    const params: RecordUpdateRequestParams = {
      path: this.baseDesignBlockPathStateService.pathState(),
      recordId: this.designBlockData().id,
      fieldName: 'comment',
      value: this.designBlockData().comment
    };

    const updateData = await this.bannerSocialFilesService.updatedRecordField<DesignBlockData>(params).catch(() => this.designBlockData());
    this.updateComment.emit(updateData);
  }

  public handleAttachFile(attachFileParams: AttachFileParams): void {
    this.attachFile.emit(attachFileParams);
  }
}
